import React from 'react';
import { BookOpen } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 flex flex-col items-center justify-center border-b border-brown/10 mb-8" data-id="element-98">
      <div className="flex items-center gap-2 text-forest mb-1" data-id="element-99">
        <BookOpen size={24} data-id="element-100" />
        <h1 className="font-handwriting text-3xl font-bold tracking-wide" data-id="element-101">
          Napftagebuch
        </h1>
      </div>
      <p className="font-serif text-sm text-brown/80 italic" data-id="element-102">
        Ehrliche Geschichten aus dem Hundealltag
      </p>
    </header>;
}